const aiPictures = { dj: new URL('./assets/dj-video-thumbnail.jpg', import.meta.url).href, spotify: new URL('./assets/spotify-interface.png', import.meta.url).href, news: new URL('./assets/flashnewz-thumbnail.png', import.meta.url).href };
import { createDJChat } from './dj-chat.js';
import { createMusicTest } from './music-test.js';
import gifAssets from './gif-assets.json';
const thesisUrl = new URL('./assets/Misanko_Thesis.pdf', import.meta.url);
const mediaRoot = '/mlggkflashnewz/assets/';
function projectCover(icon, top, bottom, gif, theme) {
  const cover = document.createElement('div');
  cover.className = 'project-cover ' + theme;
  cover.setAttribute('aria-hidden', 'true');
  const text = document.createElement('div');
  text.innerHTML = '<span class="cover-icon">' + icon + '</span><span>' + top + '</span><strong>' + bottom + '</strong>';
  const art = document.createElement('div');
  art.className = 'cover-art';
  art.innerHTML = theme === 'cover-news' ? '<div class="mini-news"><b>FLASH / 01</b><i></i><i></i><i></i><small>NEWS · CULTURE · IDEAS</small></div>' : theme === 'cover-taste' ? '<svg viewBox="0 0 200 180"><g fill="none" stroke="#00f0ff" stroke-width="2"><path d="M100 15L180 70L150 160H50L20 70Z M100 40L155 78L135 140H65L45 78Z M100 15V105L180 70 M100 105L150 160 M100 105L50 160 M100 105L20 70"/></g><path d="M100 35L145 85L138 143L67 136L36 76Z" fill="#b6ff0066" stroke="#b6ff00" stroke-width="4"/></svg>' : '<div class="turntable"><div class="record"></div><div class="equalizer">▂ ▅ █ ▃ ▆ ▂</div></div>';
  cover.append(text, art);
  return cover;
}
if (document.querySelector('#projects')) {
  const hero = document.querySelector('#hero');
  const about = document.querySelector('#about');
  const djbot = document.querySelector('#djbot');
  const projects = document.querySelector('#projects');
  const rows = [...projects.querySelectorAll('.project-wrapper > .row')];
  const categories = [
    { id: 'about-me', label: 'About me', icon: '👋', note: 'The CV, with a little personality', rows: [] },
    { id: 'ai-work', label: 'AI work', icon: '🤖', note: 'Newsletters, music & machine learning', rows: [], extra: djbot },
    { id: 'strategy-work', label: 'Strategy Work', icon: '🎯', note: 'Coming soon', rows: [] },
    { id: 'creative-work', label: 'Creative Work', icon: '⚡', note: 'Concepts, copy & award-winning ideas', rows: [1, 0, 2, 3, 4] },
    { id: 'side-quests', label: 'Side quests', icon: '🛸', note: 'Things that escalated beautifully', rows: [5] },
  ];
  categories.forEach(category => {
    let section = category.section;
    if (!section) {
      section = document.createElement('section');
      section.innerHTML = '<div class="container"><div class="project-wrapper"><h2 class="section-title"></h2></div></div>';
      section.querySelector('h2').textContent = category.label + ' ' + category.icon;
      const wrapper = section.querySelector('.project-wrapper');
      category.rows.forEach(index => wrapper.append(rows[index]));
      if (category.id === 'ai-work') {
        const newsletter = document.createElement('article');
        newsletter.className = 'bot-panel';
        newsletter.innerHTML = '<h3 class="project-wrapper__text-title">⚡ MLGGK Flash Newz</h3><p>Automatically generated every Monday, MLGGK Flash Newz brings fresh inspiration and topics to our agency alongside our Monday dose of coffee :)</p><a class="cta-btn cta-btn--hero" href="/mlggkflashnewz/">OPEN FLASH NEWZ →</a>';
        newsletter.prepend(projectCover('⚡', 'MLGGK', 'FLASH NEWZ', 'steal_12.gif', 'cover-news'));
        wrapper.append(newsletter);
        const dissertation = document.createElement('article');
        dissertation.className = 'bot-panel research-preview';
        dissertation.innerHTML = '<span class="research-label">MSc DISSERTATION</span><h3 class="project-wrapper__text-title">Spotify Personality Predictor</h3><p>My MSc dissertation explores whether music taste can predict personality, with a Spotify prototype and a genre-based test.</p><div class="research-links"><a class="cta-btn cta-btn--hero" href="' + thesisUrl.href + '" target="_blank" rel="noopener noreferrer">DISSERTATION PDF →</a><a class="cta-btn cta-btn--hero" href="https://github.com/MisoMisanko/Spotify_scheduler" target="_blank" rel="noopener noreferrer">PROJECT &amp; CODE →</a></div>';
        dissertation.prepend(projectCover('🎧', 'YOUR MUSIC.', 'YOUR MIND?', 'steal_24.gif', 'cover-taste'));
        const spotifyContext = document.createElement('p');
        spotifyContext.textContent = 'The original app connected to users’ Spotify accounts to analyse their listening preferences; this portfolio offers a manual experiment because Spotify’s current developer terms restrict personality profiling and using Spotify data in machine-learning models.';
        dissertation.append(spotifyContext, createMusicTest());
        const thesisVideo = document.createElement('div');
        thesisVideo.className = 'video-wrapper';
        const thesisFrame = document.createElement('iframe');
        thesisFrame.src = 'https://www.youtube-nocookie.com/embed/qKCg7t8mO5I';
        thesisFrame.title = 'Michal explains his music and personality dissertation';
        thesisFrame.loading = 'lazy';
        thesisFrame.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        thesisFrame.allowFullscreen = true;
        thesisVideo.append(thesisFrame);
        dissertation.querySelector('h3').after(thesisVideo);
        wrapper.append(dissertation);
      }
      if (category.extra) {
        const bot = category.extra.querySelector('.container');
        const panel = document.createElement('div');
        panel.className = 'bot-panel';
        while (bot.firstChild) panel.append(bot.firstChild);
        panel.prepend(projectCover('🤖', 'MOOD IN.', 'MUSIC OUT.', 'steal_07.gif', 'cover-bot'));
        panel.querySelector('iframe').remove();
        const walkthrough = document.createElement('div');
        walkthrough.className = 'video-wrapper';
        const video = document.createElement('iframe');
        video.src = 'https://www.youtube-nocookie.com/embed/tJLaIHF4Pyw';
        video.title = 'DJ Bot demo';
        video.loading = 'lazy';
        video.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen';
        video.allowFullscreen = true;
        walkthrough.append(video);
        const explanation = walkthrough.cloneNode(true);
        explanation.querySelector('iframe').src = 'https://www.youtube-nocookie.com/embed/qeGLECuaNG8';
        explanation.querySelector('iframe').title = 'Michal explains the DJ Bot';
        const explanationLabel = document.createElement('p');
        explanationLabel.textContent = 'HOW IT WORKS';
        const demoLabel = document.createElement('p');
        demoLabel.textContent = 'DEMO';
        demoLabel.className = explanationLabel.className = 'video-caption';
        panel.querySelector('h2').after(demoLabel, walkthrough, explanationLabel, explanation);
        const tryPrompt = document.createElement('div');
        tryPrompt.className = 'dj-try-prompt';
        tryPrompt.innerHTML = '<span aria-hidden="true">↓ ↓ ↓</span><strong>YOUR NEXT PLAYLIST STARTS HERE</strong><span>Tell me your mood. Get your music. 🎧</span>';
        panel.append(tryPrompt, createDJChat());
        wrapper.querySelector('h2').after(panel);
        category.extra.remove();
      }
      projects.before(section);
    }
    section.id = category.id;
    section.classList.add('portfolio-view');
    section.querySelector('h2').textContent = category.label + ' ' + category.icon;
    category.section = section;
  });
  const projectViews = [];
  const forewords = { 'ai-work': 'I studied Data Science and AI for Creative Industries at UAL and mostly use my skills to create useful tools at work or fun things wherever they seem useful. Just like this portfolio.', 'creative-work': 'Campaigns I helped bring to life—pick a picture to see the work.', 'side-quests': 'The projects that took me somewhere unexpected.', 'strategy-work': 'Strategy projects are coming soon.' };
  categories.forEach(category => {
    const wrapper = category.section.querySelector('.project-wrapper');
    const intro = document.createElement('p'); intro.className = 'section-foreword'; intro.textContent = forewords[category.id];
    wrapper.querySelector('h2').after(intro);
    const grid = document.createElement('div'); grid.className = 'project-picker'; wrapper.append(grid);
    if (category.id === 'strategy-work') {
      intro.innerHTML = 'I work across the whole strategy process: surveys and research, defining the problem, writing briefs, reviewing creative work, and taking it through client meetings and presentations. From finding the problem to shaping the solution :)<br/><br/>I’d be very happy to discuss what I currently do, but I’d prefer to do so over coffee :)<br/><br/>But here are the clients I work with:';
      grid.remove();
      const logos = document.createElement('div'); logos.className = 'strategy-client-logos';
      [
        ['Volkswagen Slovakia', new URL('./assets/client-volkswagen.png', import.meta.url).href],
        ['ČSOB', new URL('./assets/client-csob.png', import.meta.url).href],
        ['SPP', new URL('./assets/client-spp.png', import.meta.url).href],
        ['Audi', new URL('./assets/client-audi.png', import.meta.url).href],
        ['CUPRA', new URL('./assets/client-cupra.png', import.meta.url).href],
        ['VLK', new URL('./assets/client-vlk.png', import.meta.url).href]
      ].forEach(([name, src]) => {
        const frame = document.createElement('div'); const logo = document.createElement('img'); logo.src = src; logo.alt = name; logo.loading = 'lazy'; frame.append(logo); logos.append(frame);
      });
      wrapper.append(logos);
      const impressed = document.createElement('p'); impressed.className = 'section-foreword'; impressed.textContent = 'These brands were impressed by my work:';
      const impressedLogos = document.createElement('div'); impressedLogos.className = 'strategy-client-logos';
      [
        ['Orange', new URL('./assets/brand-orange.png', import.meta.url).href],
        ['Škoda', new URL('./assets/brand-skoda.png', import.meta.url).href],
        ['4ka', new URL('./assets/brand-4ka.png', import.meta.url).href]
      ].forEach(([name, src]) => {
        const frame = document.createElement('div'); const logo = document.createElement('img'); logo.src = src; logo.alt = name; logo.loading = 'lazy'; frame.append(logo); impressedLogos.append(frame);
      });
      wrapper.append(impressed, impressedLogos);
    }
    if (category.id === 'about-me') {
      intro.remove();
      grid.remove();
      const welcome = document.createElement('div');
      welcome.className = 'about-welcome bot-panel';
      welcome.innerHTML = '<p>Hello everyone, and welcome to my portfolio :)</p><p>You can view my CV here, but if you prefer a cooler version, keep scrolling.</p>';
      const cv = about.querySelector('a[href]').cloneNode(true);
      cv.textContent = 'View my CV';
      cv.removeAttribute('download');
      const scroll = document.createElement('button');
      scroll.type = 'button'; scroll.className = 'cv-scroll-prompt';
      scroll.innerHTML = 'or keep scrolling :)<span aria-hidden="true">↓</span>';
      const story = document.createElement('div');
      story.className = 'cv-story';
      const jumpNav = document.createElement('nav');
      jumpNav.className = 'cv-section-nav';
      jumpNav.setAttribute('aria-label', 'About me sections');
      const stickyNav = document.createElement('nav');
      stickyNav.className = 'cv-sticky-nav'; stickyNav.hidden = true;
      stickyNav.setAttribute('aria-label', 'Jump to an About me section');
      document.body.append(stickyNav);
      const updateStickyNav = () => {
        stickyNav.hidden = category.section.hidden || jumpNav.getBoundingClientRect().bottom > 0;
        const mainNav = document.querySelector('.portal-nav');
        const header = document.querySelector('#hero');
        const headerRect = header.getBoundingClientRect();
        const progress = Number(header.style.getPropertyValue('--mobile-nav-progress')) || 0;
        const navBottom = innerWidth <= 640 ? headerRect.bottom - (headerRect.height - 40) * progress : mainNav?.getBoundingClientRect().bottom || 0;
        const top = innerWidth <= 640 ? Math.max(0, navBottom) : Math.max(10, navBottom + 10);
        stickyNav.style.top = top + 'px';
        category.section.style.setProperty('--cv-scroll-offset', (top + stickyNav.offsetHeight + 24) + 'px');
      };
      window.addEventListener('scroll', updateStickyNav, { passive: true });
      window.addEventListener('hashchange', updateStickyNav);
      window.addEventListener('mobile-nav-progress', updateStickyNav);
      new ResizeObserver(updateStickyNav).observe(document.querySelector('#hero'));
      const cvSections = [
        ['schools', 'The schools I attended'],
        ['places', 'The places I’ve lived'],
        ['companies', 'The companies I’ve worked for'],
        ['skills', 'The skills I have'],
        ['person', 'The person I am']
      ];
      cvSections.forEach(([id, title]) => {
        const part = document.createElement('section');
        part.id = 'cv-' + id; part.className = 'cv-section bot-panel';
        const heading = document.createElement('h3'); heading.textContent = title;
        heading.className = 'flash-name cv-section-heading';
        part.append(heading);
        if (id === 'schools') {
          const school = document.createElement('article'); school.className = 'school-entry';
          const pictures = document.createElement('div'); pictures.className = 'school-pictures';
          [
            [new URL('./assets/gjh-school.png', import.meta.url).href, 'Gymnázium Jura Hronca school building', 'school-photo'],
            [new URL('./assets/gjh-logo.png', import.meta.url).href, 'Gymnázium Jura Hronca logo', 'school-logo'],
            [new URL('./assets/gjh-ib.png', import.meta.url).href, 'International Baccalaureate logo', 'school-ib']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; pictures.append(image);
          });
          const text = document.createElement('div'); text.className = 'school-text';
          const name = document.createElement('h4'); name.textContent = 'Gymnázium Jura Hronca';
          const description = document.createElement('p'); description.textContent = 'I graduated from the IB programme in 2013.';
          text.append(name, description); school.append(pictures, text); part.append(school);
          const imperial = document.createElement('article'); imperial.className = 'school-entry imperial-entry';
          const collage = document.createElement('div'); collage.className = 'imperial-pictures';
          [
            [new URL('./assets/imperial-campus.png', import.meta.url).href, 'Imperial College London campus', 'imperial-campus'],
            [new URL('./assets/imperial-logo.png', import.meta.url).href, 'Imperial College London logo', 'imperial-logo'],
            [new URL('./assets/imperial-microscope.png', import.meta.url).href, 'Microscope illustration', 'imperial-microscope'],
            ['https://upload.wikimedia.org/wikipedia/commons/7/73/Brian_May_Portrait_-_David_J_Cable_%28cropped%29.jpg', 'Brian May, Queen’s guitarist', 'imperial-may'],
            ['https://upload.wikimedia.org/wikipedia/commons/4/43/Alexander_Fleming_1945_%28cropped%29.jpg', 'Sir Alexander Fleming', 'imperial-fleming']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy';
            if (className === 'imperial-may' || className === 'imperial-fleming') {
              const figure = document.createElement('figure'); figure.className = className + ' portrait-card';
              image.className = '';
              const caption = document.createElement('figcaption'); caption.textContent = className === 'imperial-may' ? 'Brian May' : 'Sir Alexander Fleming';
              figure.append(image, caption); collage.append(figure);
            } else { collage.append(image); }
          });
          const imperialText = document.createElement('div'); imperialText.className = 'school-text';
          imperialText.innerHTML = '<h4>Imperial College London</h4><p>After high school, I went to Imperial College London—just so I could say I went to the same school as Queen’s guitarist or the guy who discovered penicillin.</p>';
          imperial.append(collage, imperialText); part.append(imperial);
          const medicine = document.createElement('article'); medicine.className = 'school-entry medicine-entry';
          const medicinePictures = document.createElement('div'); medicinePictures.className = 'school-pictures';
          [
            [new URL('./assets/charles-medicine-campus.png', import.meta.url).href, 'Motol hospital campus in Prague', 'school-photo'],
            [new URL('./assets/charles-medicine-logo.png', import.meta.url).href, 'Second Faculty of Medicine, Charles University logo', 'medicine-logo']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; medicinePictures.append(image);
          });
          const medicineText = document.createElement('div'); medicineText.className = 'school-text';
          medicineText.innerHTML = '<h4>2. lékařská fakulta Univerzity Karlovy v Praze</h4><p>Then I moved to Prague to study medicine, but left after three years.</p>';
          medicine.append(medicinePictures, medicineText); part.append(medicine);
          const ual = document.createElement('article'); ual.className = 'school-entry ual-entry';
          const ualPictures = document.createElement('div'); ualPictures.className = 'ual-pictures';
          [
            [new URL('./assets/ual-campus.png', import.meta.url).href, 'London College of Communication campus', 'ual-campus'],
            [new URL('./assets/ual-logo.png', import.meta.url).href, 'University of the Arts London logo', 'ual-logo'],
            [new URL('./assets/ual-wanted.png', import.meta.url).href, 'UAL: Wanted idealists, shakers, imaginers, improvers', 'ual-wanted']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; ualPictures.append(image);
          });
          const alumni = document.createElement('div'); alumni.className = 'ual-alumni';
          [
            ['Colin Firth', new URL('./assets/ual-colin-firth.png', import.meta.url).href],
            ['James Bond', new URL('./assets/ual-james-bond.png', import.meta.url).href],
            ['M.I.A.', 'https://thumb.wikimedia.org/wikipedia/commons/thumb/d/d6/MIA_press_photo_2016.png/330px-MIA_press_photo_2016.png'],
            ['Jimmy Choo', 'https://thumb.wikimedia.org/wikipedia/commons/thumb/b/bb/Jimmy_Choo_2016.png/330px-Jimmy_Choo_2016.png']
          ].forEach(([name, src]) => {
            const figure = document.createElement('figure'); const image = document.createElement('img'); image.src = src; image.alt = name; image.loading = 'lazy';
            const caption = document.createElement('figcaption'); caption.textContent = name; figure.append(image, caption); alumni.append(figure);
            if (name === 'M.I.A.') {
              figure.classList.add('mia-portrait');
              const song = document.createElement('audio');
              song.src = new URL('./assets/mia-paper-planes.mp3', import.meta.url).href;
              song.preload = 'none';
              const player = document.createElement('button');
              player.type = 'button'; player.className = 'mia-song-button cta-btn';
              const update = () => {
                player.textContent = song.paused ? '▶ Paper Planes' : 'Ⅱ Pause Paper Planes';
                player.setAttribute('aria-pressed', String(!song.paused));
              };
              player.addEventListener('click', async () => {
                if (!song.paused) { song.pause(); return; }
                document.querySelectorAll('audio').forEach(other => { if (other !== song) other.pause(); });
                try { await song.play(); } catch { player.textContent = '▶ Try playing again'; }
              });
              song.addEventListener('play', update); song.addEventListener('pause', update); song.addEventListener('ended', update);
              const arrow = document.createElement('img');
              arrow.src = new URL('./assets/mia-play-arrow.png', import.meta.url).href;
              arrow.alt = ''; arrow.className = 'mia-play-arrow'; arrow.setAttribute('aria-hidden', 'true');
              update(); ualPictures.append(song, arrow, player);
            }
          });
          ualPictures.append(alumni);
          const ualText = document.createElement('div'); ualText.className = 'school-text';
          ualText.innerHTML = '<h4>University of the Arts London – Advertising</h4><p>Then I went back to London to finally study what I do now! Just kidding—I only went there so I could say I went to the same school as James Bond (or <a href="https://en.wikipedia.org/wiki/Category:Alumni_of_the_University_of_the_Arts_London" target="_blank" rel="noopener noreferrer">some other pretty cool names</a>).</p>';
          const works = document.createElement('div'); works.className = 'school-work-links';
          [[new URL('./assets/Misanko_Portfolio_UAL.pdf', import.meta.url).href, 'School portfolio ↗'], [new URL('./assets/UAL_Truths.pdf', import.meta.url).href, 'National lottery school project ↗']].forEach(([href, label]) => {
            const link = document.createElement('a'); link.href = href; link.textContent = label; link.className = 'cta-btn'; link.target = '_blank'; link.rel = 'noopener noreferrer'; works.append(link);
          });
          ualText.append(works); ual.append(ualPictures, ualText); part.append(ual);
          const masters = document.createElement('article'); masters.className = 'school-entry masters-entry';
          const mastersPictures = document.createElement('div'); mastersPictures.className = 'masters-pictures';
          [
            [new URL('./assets/cci-campus.png', import.meta.url).href, 'UAL Camberwell campus', 'masters-campus'],
            [new URL('./assets/cci-vr.png', import.meta.url).href, 'Virtual reality demonstration at UAL', 'masters-vr'],
            [new URL('./assets/cci-future-play.png', import.meta.url).href, 'Creative Computing Institute Future Play event', 'masters-event'],
            [new URL('./assets/cci-logo.png', import.meta.url).href, 'UAL Creative Computing Institute logo', 'masters-logo']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; mastersPictures.append(image);
          });
          const mastersText = document.createElement('div'); mastersText.className = 'school-text';
          mastersText.innerHTML = '<h4>And finally – UAL again – Data Science and AI for Creative Industries</h4><p>Finally, I went back to London for my MSc—this time not for the celebrities, but so I could make cool things like these:</p>';
          const aiLink = document.createElement('a'); aiLink.href = '#ai-work'; aiLink.className = 'cta-btn masters-ai-link'; aiLink.textContent = 'Explore AI work →';
          mastersText.append(aiLink); masters.append(mastersPictures, mastersText); part.append(masters);
        }
        if (id === 'places') {
          const place = document.createElement('article'); place.className = 'school-entry place-entry';
          const pictures = document.createElement('div'); pictures.className = 'place-pictures';
          [
            [new URL('./assets/bratislava-city.png', import.meta.url).href, 'Bratislava skyline at sunset', 'place-photo'],
            [new URL('./assets/bratislava-logo.png', import.meta.url).href, 'Bratislava city logo', 'place-logo']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; pictures.append(image);
          });
          const text = document.createElement('div'); text.className = 'school-text';
          text.innerHTML = '<h4>Bratislava</h4><p>The place where it all began—I’ve lived here for most of my life, and it’s where I live now.</p>';
          place.append(pictures, text); part.append(place);
          const london = document.createElement('article'); london.className = 'school-entry place-entry london-entry';
          const londonPictures = document.createElement('div'); londonPictures.className = 'london-pictures';
          [
            [new URL('./assets/london-big-ben.png', import.meta.url).href, 'Big Ben and red London buses', 'london-big-ben'],
            [new URL('./assets/london-eye.png', import.meta.url).href, 'London Eye at sunset', 'london-eye'],
            [new URL('./assets/london-tower-bridge.png', import.meta.url).href, 'Tower Bridge', 'london-tower-bridge'],
            [new URL('./assets/london-logo.png', import.meta.url).href, 'London logo', 'london-logo']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; londonPictures.append(image);
          });
          const londonText = document.createElement('div'); londonText.className = 'school-text';
          londonText.innerHTML = '<h4>London</h4><p>I lived here for over four years, and I’ll love it for the rest of my life.</p>';
          london.append(londonPictures, londonText); part.append(london);
          const prague = document.createElement('article'); prague.className = 'school-entry place-entry prague-entry';
          const praguePictures = document.createElement('div'); praguePictures.className = 'prague-pictures';
          [
            [new URL('./assets/prague-river.png', import.meta.url).href, 'Prague bridges over the Vltava', 'prague-river'],
            [new URL('./assets/prague-dancing-house.png', import.meta.url).href, 'Dancing House in Prague', 'prague-dancing-house'],
            [new URL('./assets/prague-logo.png', import.meta.url).href, 'Prague city logo', 'prague-logo']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; praguePictures.append(image);
          });
          const pragueText = document.createElement('div'); pragueText.className = 'school-text';
          pragueText.innerHTML = '<h4>Prague</h4><p>I lived here for three years while studying medicine—another city I’ll love for the rest of my life; I’m polyamorous when it comes to cities!</p>';
          prague.append(praguePictures, pragueText); part.append(prague);
        }
        if (id === 'companies') {
          const company = document.createElement('article'); company.className = 'school-entry company-entry';
          const pictures = document.createElement('div'); pictures.className = 'place-pictures company-pictures';
          [
            [new URL('./assets/wakelake-work-photo.png', import.meta.url).href, 'Wakeboarding at Wakelake', 'place-photo'],
            [new URL('./assets/wakelake-work-logo.png', import.meta.url).href, 'Wakelake logo', 'place-logo']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; pictures.append(image);
          });
          const text = document.createElement('div'); text.className = 'school-text company-text';
          text.innerHTML = '<h4>Wakelake</h4><p>What started as a part-time summer job during my studies became a full-time role between universities, including a year with full responsibility for marketing and sales.</p><p>We revamped the product portfolio and shop, launched brand collaborations, and introduced a new ticketing system—some of those changes are still working and profitable today :)</p><p>We also made fun things like this:</p>';
          const projectLink = document.createElement('a'); projectLink.href = '/projects/wakelake.html'; projectLink.className = 'cta-btn'; projectLink.textContent = 'See the Wakelake project →';
          text.append(projectLink); company.append(pictures, text); part.append(company);
          const zaraguza = document.createElement('article'); zaraguza.className = 'company-zaraguza';
          const zaraguzaIntro = document.createElement('div'); zaraguzaIntro.className = 'school-entry company-entry';
          const zaraguzaPictures = document.createElement('div'); zaraguzaPictures.className = 'place-pictures zaraguza-pictures';
          [
            [new URL('./assets/zaraguza-team.png', import.meta.url).href, 'Zaraguza Young Lions shortlist collage', 'zaraguza-team'],
            [new URL('./assets/zaraguza-logo.png', import.meta.url).href, 'Zaraguza logo', 'zaraguza-logo']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; zaraguzaPictures.append(image);
          });
          const zaraguzaText = document.createElement('div'); zaraguzaText.className = 'school-text company-text';
          zaraguzaText.innerHTML = '<h4>Zaraguza</h4><p>This was my first ad agency role: I started as a social media manager and quickly moved into a hybrid copywriter / digital ideamaker position.</p><p>Fancy words, but mostly I made things like this:</p>';
          const creativeLink = document.createElement('a'); creativeLink.className = 'cta-btn'; creativeLink.href = '#creative-work'; creativeLink.textContent = 'See creative work →'; zaraguzaText.append(creativeLink);
          zaraguzaIntro.append(zaraguzaPictures, zaraguzaText);
          const videoPrompt = document.createElement('p'); videoPrompt.className = 'company-video-prompt'; videoPrompt.innerHTML = 'Or this <span aria-hidden="true">↓</span>';
          const videoWrapper = document.createElement('div'); videoWrapper.className = 'video-wrapper';
          const video = document.createElement('iframe'); video.src = 'https://www.youtube-nocookie.com/embed/V1Zsfo2w32s'; video.title = 'Work from my time at Zaraguza'; video.loading = 'lazy'; video.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen'; video.allowFullscreen = true;
          videoWrapper.append(video); zaraguza.append(zaraguzaIntro, videoPrompt, videoWrapper); part.append(zaraguza);
          const mullenlowe = document.createElement('article'); mullenlowe.className = 'school-entry company-entry mullenlowe-entry';
          const mullenlowePictures = document.createElement('div'); mullenlowePictures.className = 'place-pictures mullenlowe-pictures';
          [
            [new URL('./assets/mullenlowe-symbol.png', import.meta.url).href, 'MullenLowe symbol', 'mullenlowe-symbol'],
            [new URL('./assets/mullenlowe-ggk-logo.png', import.meta.url).href, 'MullenLowe GGK logo', 'mullenlowe-logo']
          ].forEach(([src, alt, className]) => {
            const image = document.createElement('img'); image.src = src; image.alt = alt; image.className = className; image.loading = 'lazy'; mullenlowePictures.append(image);
          });
          const mullenloweText = document.createElement('div'); mullenloweText.className = 'school-text company-text';
          mullenloweText.innerHTML = '<h4>MullenLowe GGK</h4><p>I currently work here as a creative strategist, brought on board by the incredible <a href="https://www.linkedin.com/in/adam-horeck%C3%BD/" target="_blank" rel="noopener noreferrer">Adam Horecký</a>—together, we make strategic magic for one of Slovakia’s biggest agencies.</p><p>These are the clients I currently work with:</p>';
          const strategyLink = document.createElement('a'); strategyLink.className = 'cta-btn'; strategyLink.href = '#strategy-work'; strategyLink.textContent = 'See strategy work →';
          mullenloweText.append(strategyLink); mullenlowe.append(mullenlowePictures, mullenloweText); part.append(mullenlowe);
        }
        if (id === 'skills') {
          const skills = document.createElement('div'); skills.className = 'skills-content';
          [
            ['I understand a bit of Python.', '_bYeUj-uaMI', 'My Python skills', true],
            ['I know my way around a computer and all the usual suspects.', 'N1GmQdWzSRU', '', false],
            ['I speak English, Slovak, Czech, and a bit of German—basically like this guy, if he spoke some Slovak too.', '2Ha9GJwlus8', '', false]
          ].forEach(([text, videoId, annotation, short]) => {
            const item = document.createElement('article'); item.className = 'skill-item' + (short ? ' python-skill' : '');
            const description = document.createElement('p'); description.textContent = text; item.append(description);
            if (annotation) { const arrow = document.createElement('p'); arrow.className = 'company-video-prompt'; arrow.innerHTML = annotation + '<span aria-hidden="true">→</span>'; item.append(arrow); }
            const wrapper = document.createElement('div'); wrapper.className = 'video-wrapper' + (short ? ' skill-short' : '');
            const video = document.createElement('iframe'); video.src = 'https://www.youtube-nocookie.com/embed/' + videoId; video.title = annotation || text; video.loading = 'lazy'; video.allow = 'accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen'; video.allowFullscreen = true;
            wrapper.append(video); item.append(wrapper); skills.append(item);
          });
          const presenter = document.createElement('article'); presenter.className = 'skill-item presenter-skill';
          const presenterPhoto = document.createElement('img'); presenterPhoto.src = new URL('./assets/amateur-theatre-upright.jpg', import.meta.url).href; presenterPhoto.alt = 'Michal in costume for his amateur theatre role'; presenterPhoto.loading = 'lazy';
          const presenterText = document.createElement('div');
          const presenterDescription = document.createElement('p'); presenterDescription.textContent = 'I’m a great presenter (or so I’ve been told).';
          const theatreLink = document.createElement('a'); theatreLink.href = '/projects/theatre.html'; theatreLink.className = 'cta-btn'; theatreLink.textContent = 'See my theatre side quest →';
          presenterText.append(presenterDescription, theatreLink); presenter.append(presenterPhoto, presenterText); skills.append(presenter);
          const aiSkill = document.createElement('article'); aiSkill.className = 'skill-item';
          const aiText = document.createElement('p'); aiText.textContent = 'I know how to make fun AI things.';
          const aiButton = document.createElement('a'); aiButton.href = '#ai-work'; aiButton.className = 'cta-btn'; aiButton.textContent = 'Explore AI work →';
          const tryTitle = document.createElement('h4'); tryTitle.className = 'skill-try-title'; tryTitle.textContent = 'OR try my DJ Bot';
          aiSkill.append(aiText, aiButton, tryTitle, createDJChat()); skills.append(aiSkill);
          const [pythonSkill, computerSkill, languageSkill] = skills.querySelectorAll(':scope > .skill-item');
          [['PERSONAL', [presenter]], ['LANGUAGES', [languageSkill]], ['COMPUTER', [pythonSkill, computerSkill, aiSkill]]].forEach(([title, items]) => {
            const group = document.createElement('div'); group.className = 'skill-group';
            const heading = document.createElement('h4'); heading.className = 'flash-name skill-group-heading'; heading.textContent = title;
            group.append(heading, ...items); skills.append(group);
          });
          part.append(skills);
        }
        if (id === 'person') {
          const portrait = about.querySelector('.about-wrapper').cloneNode(true);
          portrait.querySelector('a[href]')?.remove();
          const personalText = portrait.querySelector('.about-wrapper__info');
          personalText.replaceChildren();
          const energy = document.createElement('p');
          energy.textContent = 'I’m quite fun, and people generally say they like my energy. Sometimes I can be too much. It’s good for the company I work for—not necessarily for the person sitting next to me.';
          const explore = document.createElement('p'); explore.textContent = 'If you want to find out more about me, go and have a look:';
          const sideQuests = document.createElement('a'); sideQuests.href = '#side-quests'; sideQuests.className = 'cta-btn'; sideQuests.textContent = 'Explore side quests →';
          personalText.append(energy, explore, sideQuests);
          part.append(portrait);
        }
        const jump = document.createElement('button');
        jump.type = 'button'; jump.className = 'cta-btn'; jump.textContent = title;
        jump.dataset.section = part.id;
        jump.addEventListener('click', () => part.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' }));
        const compactJump = jump.cloneNode(true);
        compactJump.textContent = { schools: 'Schools', places: 'Places', companies: 'Companies', skills: 'Skills', person: 'Me' }[id];
        compactJump.addEventListener('click', () => part.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' }));
        stickyNav.append(compactJump);
        jumpNav.append(jump); story.append(part);
      });
      scroll.addEventListener('click', () => story.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' }));
      welcome.append(cv, scroll); wrapper.append(welcome, jumpNav, story);
    }
    if (category.id === 'ai-work') {
      const dashboardPanel = document.createElement('div'); dashboardPanel.className = 'bot-panel';
      dashboardPanel.innerHTML = '<h3>Survey dashboard</h3><p>I built a custom dashboard to explore the results of a survey we conducted for a client.</p>';
      const dashboardLink = document.createElement('a'); dashboardLink.className = 'cta-btn'; dashboardLink.href = '/projects/survey-dashboard.html'; dashboardLink.textContent = 'Try the dashboard →';
      dashboardPanel.append(dashboardLink); wrapper.append(dashboardPanel);
      const dashboardFrame = document.createElement('iframe');
      dashboardFrame.src = '/projects/survey-dashboard.html'; dashboardFrame.title = 'Survey results dashboard with masked questions and answers';
      dashboardFrame.className = 'survey-dashboard-frame'; dashboardFrame.loading = 'lazy';
      dashboardPanel.append(dashboardFrame);
      [...wrapper.querySelectorAll(':scope > .bot-panel')].forEach((panel, index) => {
        const meta = [ { id: 'dj-bot', title: 'DJ Bot', picture: aiPictures.dj }, { id: 'flash-newz', title: 'MLGGK Flash Newz', picture: aiPictures.news }, { id: 'spotify-personality', title: 'Spotify Personality Predictor', picture: aiPictures.spotify }, { id: 'survey-dashboard', title: 'Survey dashboard', picture: new URL('./assets/survey-thumbnail.png', import.meta.url).href } ][index];
        const view = document.createElement('section'); view.id = meta.id; view.className = 'portfolio-view project-screen';
        const back = document.createElement('a'); back.href = '#ai-work'; back.className = 'cta-btn'; back.textContent = '← AI work';
        panel.querySelector('.project-cover')?.remove(); panel.querySelector('.research-label')?.remove(); panel.querySelector('.dj-try-prompt')?.remove();
        panel.querySelector('h2,h3').textContent = meta.title;
        if (meta.id === 'dj-bot') {
          const tryHeading = document.createElement('h3');
          tryHeading.className = 'flash-name dj-try-heading';
          tryHeading.textContent = 'TRY IT YOURSELF!';
          panel.querySelector('h2,h3').after(tryHeading, panel.querySelector('.dj-chat'));
        }
        if (meta.id === 'spotify-personality') {
          const screenshot = document.createElement('img');
          screenshot.className = 'spotify-interface-preview';
          screenshot.src = aiPictures.spotify;
          screenshot.alt = 'Spotify Personality Predictor interface showing listening patterns and a Big Five radar chart';
          screenshot.loading = 'lazy';
          panel.querySelector('.video-wrapper').after(screenshot);
        }
        view.append(back, panel); category.section.after(view); projectViews.push({ id: meta.id, section: view, category });
        grid.append(pictureButton(meta.title, meta.picture, '#' + meta.id));
      });
      ['survey-dashboard', 'flash-newz', 'dj-bot', 'spotify-personality'].forEach(id => {
        grid.append(grid.querySelector('a[href="#' + id + '"]'));
      });
    } else {
      [...wrapper.querySelectorAll(':scope > .row')].forEach(row => {
        const title = row.querySelector('h3').textContent;
        const image = row.querySelector('img'); const link = row.querySelector('a[href]');
        grid.append(pictureButton(title, image.src, link.href)); row.remove();
      });
      if (category.id === 'side-quests') {
        intro.textContent = 'I looooooove sidequests. Here are some of them:';
        grid.append(pictureButton('Amateur theatre actor', new URL('./assets/amateur-theatre-upright.jpg', import.meta.url).href, '/projects/theatre.html'));
        const newsletterUrl = 'https://friendlyneighborhoodnewsletter.substack.com/';
        const articleUrl = 'https://www.sme.sk/closer/c/kazdy-muz-mal-vlastne-pero-britski-spioni-si-neviditelny-atrament-nosili-doslova-medzi-nohami';
        [
          ['Friendly Neighborhood newsletter', new URL('./assets/newsletter-sidequest.jpg', import.meta.url).href, newsletterUrl, `Sometimes I write stuff. I wrote <a href="${articleUrl}" target="_blank" rel="noopener noreferrer">this</a>. Or <a href="${newsletterUrl}" target="_blank" rel="noopener noreferrer">this</a>.`],
          ['Photography', new URL('./assets/photography-sidequest.jpg', import.meta.url).href, 'https://misankomichal.myportfolio.com/', 'I shoot rarely, but when I do, I love it :)']
        ].forEach(([title, image, href, description], index) => {
          const id = index === 0 ? 'friendly-neighborhood-newsletter' : 'photography';
          const view = document.createElement('section'); view.id = id; view.className = 'portfolio-view project-screen';
          const back = document.createElement('a'); back.className = 'cta-btn'; back.href = '#side-quests'; back.textContent = '← Side quests';
          const panel = document.createElement('div'); panel.className = 'bot-panel';
          const heading = document.createElement('h2'); heading.textContent = title;
          const photo = document.createElement('img'); photo.className = 'sidequest-project-image'; photo.src = image; photo.alt = title;
          const text = document.createElement('p'); text.innerHTML = description;
          const visit = document.createElement('a'); visit.className = 'cta-btn'; visit.href = href; visit.target = '_blank'; visit.rel = 'noopener noreferrer'; visit.textContent = index === 0 ? 'Read my Substack →' : 'Explore my photography →';
          panel.append(heading, photo, text, visit); view.append(back, panel); category.section.after(view);
          projectViews.push({ id, section: view, category });
          grid.append(pictureButton(title, image, '#' + id));
        });
      }
    }
  });
  function pictureButton(title, picture, href) {
    const link = document.createElement('a'); link.className = 'picture-button'; link.href = href;
    const image = document.createElement('img'); image.src = picture; image.alt = ''; image.loading = 'lazy';
    if (picture === aiPictures.spotify) link.classList.add('spotify-picture-button');
    if (title === 'Amateur theatre actor') link.classList.add('theatre-picture-button');
    const headline = document.createElement('h3'); headline.textContent = title;
    const arrow = document.createElement('span'); arrow.className = 'picture-arrow'; arrow.textContent = 'OPEN PROJECT →';
    link.append(image, headline, arrow); return link;
  }
  about.id = 'lore';
  about.querySelector('h2').textContent = 'Lore 🧠';
  const aboutLink = about.querySelector('a[href]');
  aboutLink.href = '#about-me';
  aboutLink.textContent = 'About me';
  aboutLink.removeAttribute('target');
  projects.remove();
  document.querySelector('.hero-cta').remove();
  const nav = document.createElement('nav');
  nav.className = 'flash-nav portal-nav';
  nav.setAttribute('aria-label', 'Portfolio microsites');
  categories.forEach(category => {
    const link = document.createElement('a');
    link.href = '#' + category.id;
    link.innerHTML = '<span class="portal-icon">' + category.icon + '</span><span>' + category.label + '</span>';
    link.dataset.view = category.id;
    nav.append(link);
  });
  hero.append(nav);
  const home = document.createElement('a');
  home.className = 'view-home-link';
  home.href = '#home';
  home.textContent = '← HOME';
  hero.prepend(home);
  const mobileTop = document.createElement('a');
  mobileTop.className = 'mobile-back-to-top'; mobileTop.href = '#top'; mobileTop.textContent = '↑ Back to top';
  mobileTop.addEventListener('click', event => { event.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
  hero.prepend(mobileTop);
  let mobileFrame = 0;
  const measureMobileNav = () => {
    hero.style.removeProperty('--mobile-header-height');
    hero.style.setProperty('--mobile-nav-progress', 0);
    hero.style.setProperty('--mobile-nav-height', nav.scrollHeight + 'px');
    if (innerWidth <= 640 && document.body.classList.contains('in-microsite')) {
      hero.style.setProperty('--mobile-header-height', hero.getBoundingClientRect().height + 'px');
    }
  };
  const updateMobileNav = () => {
    if (mobileFrame) return;
    mobileFrame = requestAnimationFrame(() => {
    mobileFrame = 0;
    const progress = innerWidth <= 640 ? Math.min(1, Math.max(0, scrollY / 220)) : 0;
    hero.style.setProperty('--mobile-nav-progress', progress);
    nav.inert = progress >= 0.98;
    home.inert = progress >= 0.98;
    mobileTop.inert = progress < 0.5;
    window.dispatchEvent(new Event('mobile-nav-progress'));
    });
  };
  window.addEventListener('scroll', updateMobileNav, { passive: true });
  window.addEventListener('resize', () => { measureMobileNav(); updateMobileNav(); });
  window.addEventListener('hashchange', updateMobileNav);
  updateMobileNav();
  function showView() {
    const aliases = { about: 'home', lore: 'home', djbot: 'ai-work', projects: 'creative-work' };
    let id = location.hash.slice(1);
    id = aliases[id] || id;
    const project = projectViews.find(view => view.id === id);
    const active = project ? project.category : categories.find(category => category.id === id);
    projectViews.forEach(view => { view.section.hidden = view !== project; });
    categories.forEach(category => {
      const selected = category === active;
      category.section.hidden = !selected || !!project;
      const link = nav.querySelector('[data-view="' + category.id + '"]');
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    about.hidden = !!active;
    document.body.classList.toggle('in-microsite', !!active);
    home.hidden = !active;
    measureMobileNav();
    if (active || id === 'home' || id === '') window.scrollTo(0, 0);
    document.title = active ? (project ? project.section.querySelector('h2,h3').textContent : active.label) + ' | Mišo Mišanko' : 'Mišo Mišanko | The Mišoverse';
  }
  window.addEventListener('hashchange', showView);
  showView();
}

const mainGifs = [...gifAssets];
// Shuffle the main Flash Newz GIF collection once, without repeats between sections.
for (let i = mainGifs.length - 1; i > 0; i--) {
  const j = Math.floor(Math.random() * (i + 1));
  [mainGifs[i], mainGifs[j]] = [mainGifs[j], mainGifs[i]];
}
document.querySelectorAll('body > section').forEach((section, index) => {
  const rail = document.createElement('div');
  rail.className = 'gif-rail';
  rail.setAttribute('aria-hidden', 'true');
  const gifCount = section.id === 'about-me' ? 60 : 16;
  for (let n = 0; n < gifCount; n++) {
    const gif = document.createElement('img');
    gif.src = mediaRoot + mainGifs[(index * 16 + n) % mainGifs.length];
    gif.alt = '';
    gif.loading = 'lazy';
    gif.draggable = false;
    gif.style.setProperty('--sticker-turn', ((index * 13 + n * 11) % 25 - 12) + 'deg');
    gif.title = 'Drag to move';
    rail.append(gif);
  }
  section.append(rail);
  let previousLayout = '';
  function arrangeGifs() {
    if (section.hidden || !section.offsetHeight) return;
    const wide = innerWidth >= 1280;
    const layout = `${wide}:${section.offsetHeight}:${innerWidth}`;
    if (layout === previousLayout) return;
    previousLayout = layout;
    const capacity = Math.max(1, Math.floor((section.offsetHeight - 40) / 160));
    const maximum = Math.min(gifCount / 2, capacity, Math.max(2, Math.ceil(section.offsetHeight / 220)));
    const minimum = Math.min(maximum, Math.max(1, Math.ceil(maximum * 0.65)));
    const perSide = Math.floor(minimum + Math.random() * (maximum - minimum + 1));
    const count = wide ? perSide * 2 : 8;
    const cellHeight = (section.offsetHeight - 40) / perSide;
    [...rail.children].forEach((gif, n) => {
      gif.hidden = n >= count;
      if (gif.hidden) return;
      gif.style.position = wide ? 'absolute' : 'relative';
      const outward = 126 + Math.floor(Math.random() * 12);
      gif.style.left = wide ? (n % 2 ? 'auto' : `-${outward}px`) : 'auto';
      gif.style.right = wide && n % 2 ? `-${outward}px` : 'auto';
      gif.style.top = wide ? (20 + Math.floor(n / 2) * cellHeight + Math.random() * Math.max(0, cellHeight - 140)) + 'px' : 'auto';
      gif.style.bottom = 'auto';
    });
  }
  new ResizeObserver(arrangeGifs).observe(section);
  window.addEventListener('resize', arrangeGifs);
  arrangeGifs();
});

// Pointer capture keeps dragging local to the sticker, including on touch screens.
document.querySelectorAll('.gif-rail img').forEach(gif => {
  let drag;
  gif.addEventListener('pointerdown', event => {
    if (event.button !== 0) return;
    event.preventDefault();
    const left = gif.offsetLeft, top = gif.offsetTop;
    gif.style.position = 'absolute'; gif.style.left = left + 'px'; gif.style.top = top + 'px';
    gif.style.right = 'auto'; gif.style.bottom = 'auto';
    gif.classList.add('sticker-dragging');
    drag = { x: event.clientX, y: event.clientY, left, top };
    gif.setPointerCapture(event.pointerId);
  });
  gif.addEventListener('pointermove', event => {
    if (!drag) return;
    const rail = gif.parentElement.getBoundingClientRect();
    const left = Math.max(-rail.left, Math.min(innerWidth - rail.left - gif.offsetWidth, drag.left + event.clientX - drag.x));
    gif.style.left = left + 'px';
    gif.style.top = Math.max(0, drag.top + event.clientY - drag.y) + 'px';
  });
  function finish() {
    if (drag) {
      const a = gif.getBoundingClientRect();
      const overlaps = [...document.querySelectorAll('.gif-rail img:not([hidden])')].some(other => {
        if (other === gif || !other.getClientRects().length) return false;
        const b = other.getBoundingClientRect();
        return a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
      });
      if (overlaps) { gif.style.left = drag.left + 'px'; gif.style.top = drag.top + 'px'; }
    }
    drag = null; gif.classList.remove('sticker-dragging');
  }
  gif.addEventListener('pointerup', finish);
  gif.addEventListener('pointercancel', finish);
});

const audio = document.createElement('audio');
audio.src = `${mediaRoot}song.mp3`;
audio.loop = true;
audio.preload = 'none';
audio.volume = 0.6;
document.body.append(audio);
const button = document.createElement('button');
button.id = 'musicbtn';
button.type = 'button';
button.textContent = 'Add music';
button.setAttribute('aria-label', 'Play background music');
button.setAttribute('aria-pressed', 'false');
document.body.append(button);
let manuallyStopped = false;
function updateMusic() {
  const playing = !audio.paused;
  button.textContent = playing ? 'Current Joys - Kids' : 'Add music';
  button.classList.toggle('on', playing);
  button.setAttribute('aria-pressed', String(playing));
  button.setAttribute('aria-label', playing ? 'Pause background music' : 'Play background music');
}
async function startMusic() {
  try { await audio.play(); } catch { /* Browser may require another interaction. */ }
  updateMusic();
}
button.addEventListener('click', () => {
  if (audio.paused) { manuallyStopped = false; startMusic(); }
  else { manuallyStopped = true; audio.pause(); }
});
audio.addEventListener('play', updateMusic);
audio.addEventListener('pause', updateMusic);

